import {
  map,
  withLatestFrom,
  tap,
  filter,
  switchMap,
  mergeMap
} from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { authSelectors } from '../auth/auth.selectors'
import { AppState } from '../core.state'
import { settingsActions, SettingsProperties } from './settings.actions'
import { authActions } from '../auth/auth.actions'
import { settingSelectors } from './settings.selectors'
import { PushNotificationService } from '../push-notification.service'
import { AuthService } from '../auth/auth.service'

@Injectable()
export class SettingsEffects implements OnInitEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private pushNotificationService: PushNotificationService,
    private authService: AuthService
  ) {}

  ngrxOnInitEffects() {
    return settingsActions.initActions()
  }

  initActions = createEffect(() =>
    this.actions$.pipe(
      ofType(settingsActions.initActions),
      withLatestFrom(this.store.select(authSelectors.selectMember)),
      map(([action, member]) => {
        const language = member?.language
          ? member.language
          : environment.defaultLanguage

        return settingsActions.setOneById({
          id: 'language',
          value: language
        })
      })
    )
  )

  setMultipleSettings = createEffect(() =>
    this.actions$.pipe(
      ofType(settingsActions.setMultipleSettings),
      mergeMap((settings) =>
        Object.entries(settings).map(([key, value]) =>
          settingsActions.setOneById({ id: key as SettingsProperties, value })
        )
      )
    )
  )

  onLoadMember = createEffect(
    () =>
      this.actions$.pipe(
        ofType(authActions.loadMember),
        withLatestFrom(
          this.store.select(settingSelectors.selectById, 'fcmToken')
        ),
        filter(([_, fcmToken]) => !!fcmToken),
        switchMap(([_, fcmToken]) =>
          this.pushNotificationService.postPushNotificationToken(fcmToken)
        )
      ),
    {
      dispatch: false
    }
  )

  onLoadMemberDeviceInfo = createEffect(
    () =>
      this.actions$.pipe(
        ofType(authActions.loadMember),
        withLatestFrom(this.store.select(settingSelectors.selectDeviceInfo)),
        filter(([_, deviceInfo]) => !!deviceInfo),
        switchMap(([_, deviceInfo]) =>
          this.authService.updateProfile({
            userAgents: JSON.stringify(deviceInfo)
          })
        )
      ),
    {
      dispatch: false
    }
  )
}
